import { Image, Stack, Text, useColorModeValue } from '@ecoinvent/ui';

import nothingDark from 'assets/nothing-dark.svg';
import nothing from 'assets/nothing.svg';

const NoFlowView = () => {
  const nothingImage = useColorModeValue(nothing, nothingDark);
  const grayTextColor = useColorModeValue('gray.500', 'gray.400');

  return (
    <Stack spacing={0} justifyContent="center" alignItems="center" w="100%" flex={1}>
      <Stack direction="column" alignItems="center" justifyContent="center" spacing={4}>
        <Image src={nothingImage} alt="No flows found" w="300px" />
        <Stack alignItems="center" spacing={0}>
          <Text p={0} color={grayTextColor}>
            No flows match the current filters
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default NoFlowView;
